export function getFirstLastName(name: string | undefined) {
  if (name) {
    const arrayName = name.split(' ');
    return {
      firstName: arrayName[0],
      lastName: arrayName[1] ?? '',
    };
  }
  return {
    firstName: '',
    lastName: '',
  };
}

export const formatUserName = (name: string = '') => {
  const [firstName, ...lastNames] = name.split(' ');
  return firstName && lastNames.length
    ? `${firstName[0]}. ${lastNames.join(' ')}`
    : name;
};
